<template>
  <div class="tracking-status">
    <div class="status tracking-dots" :class="isActive(1).active">
      <div class="event-location">
        {{ this.isValidProp(cc, 'departure.location').toLowerCase() }}
      </div>
      <div class="event-time">{{ formatDate(cc.departure) }}</div>
    </div>
    <div
      class="status tracking-dots"
      v-if="cs === 2"
      :class="isActive(2).active"
    >
      <div class="event-location">
        {{ this.isValidProp(cc, 'current.location').toLowerCase() }}
      </div>
      <div class="event-time">{{ formatDate(cc.current) }}</div>
    </div>
    <div class="status tracking-dots" :class="isActive(3).active">
      <div class="event-location">
        {{ this.isValidProp(cc, 'arrival.location').toLowerCase() }}
      </div>
      <div class="event-time">
        {{ formatDate(cc.arrival) }}
        <span
          v-b-tooltip.hover
          :title="$t('invoices.tracking.container.delayed')"
          v-if="isLate"
          ><b-icon-exclamation-triangle-fill class="text-warning"
        /></span>
      </div>
    </div>
  </div>
</template>
<script>
import { validateMixin } from '@/mixins/Validate'

export default {
  props: ['cc', 'cs'],
  computed: {
    isLate() {
      if (
        this.isValidProp(this.cc, 'arrival.time', undefined) &&
        this.isValidProp(this.cc, 'aarival.location', undefined) &&
        this.isValidProp(this.cc, 'current.location', undefined)
      ) {
        let currentDate = new Date()
        let arrivalDate =
          this.cc && this.cc.arrival && this.cc.arrival.time !== null
            ? new Date(this.cc.arrival.time)
            : ''
        return (
          currentDate > arrivalDate &&
          this.cc.arrival.location !== this.cc.current.location
        )
      }
      return false
    }
  },
  methods: {
    formatDate(rawDateFormat) {
      return rawDateFormat && rawDateFormat.time
        ? this.$moment(new Date(rawDateFormat.time)).format('MMM DD, YYYY')
        : 'NA'
    },
    isActive(i) {
      if (this.cs === i) {
        return {
          active: 'active'
        }
      } else if (this.cs < i) {
        return {
          active: 'disabled'
        }
      } else {
        return {
          active: 'completed'
        }
      }
    }
  },
  mixins: [validateMixin]
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/variables';
.tracking-status {
  margin-top: 1rem;
  .status {
    border-left: 3px solid $dc-svg;
    padding-left: 19px;
    position: relative;
    padding-bottom: 20px;
    margin-left: 1rem;
    text-transform: capitalize;
    h4,
    h3 {
      line-height: 1;
    }
    &:before {
      margin-left: -30px;
    }
    &:after {
      margin-left: -25px;
      top: 5px;
    }
    &.active,
    &.disabled {
      border-left-color: $gray-300;
    }
    &:last-child {
      border-left-color: transparent;
    }
    .event-status {
      font-size: 0.8rem;
      text-transform: uppercase;
      color: $gray-600;
    }
    .event-time {
      font-size: 0.8rem;
    }
  }
}
</style>
